export const qs = (selector, ctx = document) => ctx.querySelector(selector);

export const qsa = (selector, ctx = document) => Array.from(ctx.querySelectorAll(selector));

export const degToRad = degrees => degrees * Math.PI / 180;

export const randomInteger = (min, max) => Math.floor(min + Math.random() * (max + 1 - min));

export const isTouchDevice = () => window.matchMedia('(pointer: coarse) and (hover: none)').matches;

export const getArrayDeltaPercent = array => 100 / (array.length - 1);
